import posed from 'react-pose'

export const PoseInner = posed.div()
